import { render } from "./MenuTableUpdate.vue?vue&type=template&id=4c82b860&scoped=true"
import script from "./MenuTableUpdate.vue?vue&type=script&lang=js"
export * from "./MenuTableUpdate.vue?vue&type=script&lang=js"

import "./MenuTableUpdate.vue?vue&type=style&index=0&id=4c82b860&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c82b860"]])

export default __exports__